import api from './api';

const websiteContactService = {
  // Get contact submissions for the agent
  getSubmissions: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      // Add filters to query parameters
      if (filters.status && filters.status !== 'all') {
        params.append('status', filters.status);
      }
      if (filters.limit) {
        params.append('limit', filters.limit);
      }
      if (filters.page) {
        params.append('page', filters.page);
      }
      
      const queryString = params.toString();
      const url = queryString ? `/website-contact/submissions?${queryString}` : '/website-contact/submissions';
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching submissions:', error);
      throw error;
    }
  },

  // Update submission status
  updateStatus: async (submissionId, status) => {
    try {
      const response = await api.put(`/website-contact/submissions/${submissionId}/status`, { 
        status 
      });
      return response.data;
    } catch (error) {
      console.error('Error updating submission status:', error);
      throw error;
    }
  },

  // Get submission by ID
  getSubmissionById: async (submissionId) => {
    try {
      const response = await api.get(`/website-contact/submissions/${submissionId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching submission:', error);
      throw error;
    }
  }
};

export default websiteContactService;
